import React, { useState } from 'react'
import { Box, Grid, Divider, List, ListItem, Button, Collapse, IconButton, } from '@mui/material'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { getNpoProgramsAndResults } from '../../../Store/npoProfile/npoProfile';
import Loading from '../../../Components/Loader/Loading';
import { CorrectState } from './MapList';
import NewMap from './NewMap';

export default function ProgramsAndResults({ orgName, id }) {

  const RenderParagraphPair = (label, text) => (
    <Box sx={{ mt: 3, width: '100%' }}>
      <ParagraphComp text={label || '-'} className='text-[#004878] text-2xl mb-2 font-bold' />
      <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
      <ParagraphComp text={text || '-'} className='text-md mt-2 text-black text-justify' />
    </Box>
  );

  const { data: programsAndResults, isPending: programsAndResultsLoading } = useQuery({
    queryKey: ['programsAndResults', orgName],
    queryFn: () => getNpoProgramsAndResults(orgName),
    refetchOnWindowFocus: false,
    enabled: !!orgName
  });
  // GSI00000494

  const [selectedProgram, setSelectedProgram] = useState(0);
  const [open, setOpen] = useState(false);

  const programsAndResultsData = programsAndResults?.documents?.[selectedProgram] || '';

  const formatCurrency = (value) => {
    if (isNaN(value)) return '-'; // Handle invalid or null values
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR', // Change to your desired currency code
      minimumFractionDigits: 2,
    }).format(value);
  };

  const scrollToSection = () => {
    document.getElementById("involved")?.scrollIntoView({ behavior: "smooth" });
  };

  const containerStyle = {
    width: '230px', // Fixed width for the container
    height: '230px', // Fixed height for the container
    borderRadius: '5px', // Rounded corners
    overflow: 'hidden', // Ensures the image doesn't overflow the container
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f0f0', // Optional: Add a background color
  };

  const imageStyle = {
    width: '100%', // Make the image fill the container width
    height: '100%', // Make the image fill the container height
    objectFit: 'contain', // Ensures the image covers the container without stretching
    borderRadius: '5px', // Rounded corners for the image
  };


  return (
    <>

      <div id={id} >
        {programsAndResultsLoading ? <Box sx={{ mt: 5, px: 4, display: 'flex', justifyContent: 'center' }}><Loading /></Box> : <Box sx={{ mt: 3 }}>
          <Divider sx={{ color: '#E5E8EB', marginBottom: '10px', borderTopWidth: 3 }} />
          <Box sx={{ backgroundColor: '#004878', borderRadius: '16px', color: '#E5E8EB', borderTopWidth: 3, padding: '12px', width: '50%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <ParagraphComp text="Programmes & Results" className="text-white text-2xl font-bold" />
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <svg
                    width="10"
                    height="2"
                    viewBox="0 0 10 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 1H10"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                ) : (
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 0V10M0 5H10"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>

                )}
              </IconButton>
            </Box>

            <Collapse in={open} timeout="auto" unmountOnExit>
              {programsAndResults?.documents || programsAndResults?.documents.length > 0 ?
                <List sx={{ py: 0 }}>
                  {programsAndResults?.documents?.map((item, index) => (
                    <ListItem
                      key={index}
                      disableGutters
                      sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #ccc', borderRadius: '5px', mb: 0.5, px: 1, mt: 1, backgroundColor: '#edf2f6' }}
                    >
                      <div className=''>
                        <ParagraphComp text={`Programme ${index + 1}`} className="text-[#004878] text-md font-bold" />
                        <ParagraphComp text={`${item?.programme_name}`} className="text-[#004878] text-md" />
                      </div>
                      <Button
                        onClick={() => setSelectedProgram(index)}
                        variant="contained"
                        sx={{
                          backgroundColor: index === selectedProgram ? '#fec74e' : 'primary.main',
                          '&:hover': {
                            backgroundColor: index === selectedProgram ? '#edb334' : 'primary.dark',
                          },
                          width: '80px'
                        }} size="small"
                      >
                        {index === selectedProgram ? 'Selected' : 'Select'}
                      </Button>
                    </ListItem>
                  ))}
                </List>
                : ''}
            </Collapse>
          </Box>
          {programsAndResults?.documents?.[selectedProgram] ?
            <>


              <Box sx={{ width: '100%', display: 'flex' }}>
                <Box sx={{ width: '50%' }}>
                  <ParagraphComp text='ˇ SOURCE: Self-reported by the organisation' className='text-[black] italic mt-[20px] font-thin text-md' />
                </Box>
                <Box sx={{ width: '50%' }}>
                  <ParagraphComp text='Last updated on: ' className='text-[black] italic mt-[20px] font-thin text-md' />
                </Box>
              </Box>
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}>
                  <Box sx={{ mt: 1, width: '100%' }}>
                    <ParagraphComp text='Programme Description' className='text-[#004878] text-2xl mb-2 font-bold' />
                    <ParagraphComp text={programsAndResultsData?.programme_name} className='text-[#004878] text-xl mb-2 font-semibold' />
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                    <ParagraphComp text={`We started ${programsAndResultsData?.programme_name} in the year ${programsAndResultsData?.programme_year} and since then ${(programsAndResultsData?.beneficiary_groups || programsAndResultsData?.other_beneficiary_group) && `served ${programsAndResultsData?.numbers_achieved ? `${programsAndResultsData?.numbers_achieved} number(s) of ` : ''}${programsAndResultsData?.beneficiary_groups ? `${programsAndResultsData?.beneficiary_groups}` : ''}${programsAndResultsData?.other_beneficiary_group ? `${programsAndResultsData?.other_beneficiary_group}` : ''}`} ${programsAndResultsData?.thematic_area ?
                      ` in the thematic area(s) of ${programsAndResultsData?.thematic_area} `
                      : ''} ${(programsAndResultsData?.pan_india === 'Yes' || programsAndResultsData?.geographies_district) ? `in ${(programsAndResultsData?.pan_india === 'Yes' && programsAndResultsData?.geographies_district === (false || null) ) ? '' : `${programsAndResultsData?.geographies_district} ${programsAndResultsData?.pan_india === 'Yes' ? 'and' : ''}`}       ${programsAndResultsData?.pan_india === 'Yes' ? ' pan India' : ''} ${(programsAndResultsData?.key_indicator || programsAndResultsData?.other_key_indicator) ? `and use the key indicator(s): ${programsAndResultsData?.key_indicator} ${(programsAndResultsData?.key_indicator && programsAndResultsData?.other_key_indicator) ? '&':''} ${programsAndResultsData?.other_key_indicator ? ` ${programsAndResultsData?.other_key_indicator}` : ''} ${programsAndResultsData?.verified ? `to track our progress, ${programsAndResultsData?.verified}` : ''}` : ''}` : ''} ${programsAndResultsData?.goal ? `and hope to reach our goal of ${programsAndResultsData?.goal}` : ''} ${programsAndResultsData?.goal_year ? `by around the year ${programsAndResultsData?.goal_year}.` : '.'}`} className='text-md mt-2 text-black text-justify' />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ width: '100%' }}>
                    <ParagraphComp text='Where we work' className='text-[#004878] text-2xl mb-2 font-bold' />
                    <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />

                    <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                      {/* <img src={mapImage} width={174} height={174} alt='logo' /> */}
                      <Box sx={{ position: 'relative', height: '460px', width: '474px' }}>
                        <NewMap selectedState={CorrectState(programsAndResultsData?.geographies_state)}
                          PanIndia={programsAndResultsData?.pan_india === 'Yes' ? true : false}
                        />
                        <Box sx={{ position: 'absolute', bottom: 0, width: '100%', height: '17%', margin: 'auto', backgroundColor: 'white', zIndex: 50 }}>
                          <ParagraphComp text={'Disclaimer: Map of India may not be to scale and is only for illustration purposes.'} className="text-[#004878] text-sm" />
                        </Box>
                      </Box>
                      <Box>
                        {programsAndResultsData.pan_india === 'Yes' ? <Box>
                          <ParagraphComp text='Works pan India:' className='text-[#004878] text-md mb-1 font-bold mt-4' />

                          <ParagraphComp text={`${programsAndResultsData.pan_india}`} className="text-[#004878] text-md" />

                        </Box> : ''}
                        <Box>
                          <ParagraphComp text='Key State(s) - District(s):' className='text-[#004878] text-md mb-1 font-bold mt-4' />
                          {programsAndResultsData?.geographies_district?.includes(",")
                            ? programsAndResultsData?.geographies_district?.split(", ").map((item, i) =>
                              <ParagraphComp text={`${item}`} className="text-[#004878] text-md" />
                            )
                            : <ParagraphComp text={`${(programsAndResultsData?.geographies_district || programsAndResultsData?.geographies_district !== null) ? programsAndResultsData?.geographies_district : '-'}`} className="text-[#004878] text-md" />
                          }
                        </Box>
                        <Box>
                          <ParagraphComp text='Geographical focus of activities:' className='text-[#004878] text-md mb-1 mt-3 font-bold' />
                          {/* <ParagraphComp text={programsAndResultsData?.focus_of_activity || '-'} className='text-md mt-1 text-black' /> */}
                          {programsAndResultsData?.focus_of_activity?.includes(",")
                            ? programsAndResultsData?.focus_of_activity?.split(", ").map((item, i) =>
                              <ParagraphComp text={`${item}`} className="text-[#004878] text-md" />
                            )
                            : <ParagraphComp text={programsAndResultsData?.focus_of_activity ? `${programsAndResultsData?.focus_of_activity}` : '-'} className="text-[#004878] text-md" />
                          }
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}>
                </Grid>
                {programsAndResultsData?.duration &&
                  <Grid item xs={6}>
                    <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2 }}>
                      <ParagraphComp text='Duration of programme:' className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={programsAndResultsData?.duration || '-'} className='text-[#004878] text-md font-bold' />
                    </Box>
                  </Grid>
                }
              </Grid>
              <Grid container spacing={2} sx={{ mt: .5 }}>
                {programsAndResultsData?.cultural_challenge ?
                  <Grid item xs={6}>
                    {RenderParagraphPair('What social or environmental or cultural challenge the organisation is addressing through this programme', programsAndResultsData?.cultural_challenge || '-')}
                  </Grid>
                  : ''
                }

                <Grid item xs={programsAndResultsData?.cultural_challenge ? 6 : 12} >
                  <Grid >
                    <Grid container spacing={2} sx={{ mt: .5 }}>
                      {programsAndResultsData?.programme_nature &&
                        <Grid item xs={6}>
                          <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', height: '100%', padding: '16px', mt: 2 }}>
                            <ParagraphComp text='Nature of Programme:' className='text-[#004878] text-md font-bold' />
                            <ParagraphComp text={programsAndResultsData?.programme_nature || '-'} className='text-[#004878] text-md ' />
                          </Box>
                        </Grid>
                      }
                      {programsAndResultsData?.programme_nature &&
                        <Grid item xs={6}>
                          <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', height: '100%', padding: '16px', mt: 2 }}>
                            <ParagraphComp text='Nature of Intervention:' className='text-[#004878] text-md font-bold' />
                            {/* <ParagraphComp text={programsAndResultsData?.programme_nature || '-'} className='text-[#004878] text-md ' /> */}
                          </Box>
                        </Grid>
                      }

                    </Grid>
                  </Grid>
                  <Grid spacing={2} >
                    <Grid container spacing={2} sx={{ mt: .5 }}>
                      {programsAndResultsData?.thematic_area &&
                        <Grid item xs={6}>
                          <Box sx={{ backgroundColor: '#EDF2F6', height: '100%', borderRadius: '16px', padding: '16px', mt: 2 }}>
                            <ParagraphComp text='Thematic area based on the International Classification of NPOs (ICNPO):' className='text-[#004878] text-md font-bold' />
                            <ParagraphComp text={programsAndResultsData?.thematic_area || '-'} className='text-[#004878] text-md ' />
                          </Box>
                        </Grid>
                      }
                      {programsAndResultsData?.social_stock_exchange &&
                        <Grid item xs={6}>
                          <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', height: '100%', padding: '16px', mt: 2 }}>
                            <ParagraphComp text='Social Stock Exchange Listing:' className='text-[#004878] text-md font-bold' />
                            <ParagraphComp text={programsAndResultsData?.social_stock_exchange || '-'} className='text-[#004878] text-md ' />
                          </Box>
                        </Grid>
                      }
                      {programsAndResultsData?.un_sustainable_development &&
                        <Grid item xs={6}>
                          <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', height: '100%', padding: '16px', mt: 2 }}>
                            <ParagraphComp text='Work towards UN Sustainable Development Goals:' className='text-[#004878] text-md font-bold' />
                            <ParagraphComp text={programsAndResultsData?.un_sustainable_development || '-'} className='text-[#004878] text-md ' />
                          </Box>
                        </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: '50px' }}>
                {/* Conditional grid item for attending challenge */}
                {programsAndResultsData?.attending_challenge && (
                  <Grid item xs={6}>
                    {RenderParagraphPair(
                      'How is the organisation addressing the challenge through this programme',
                      programsAndResultsData?.attending_challenge || '-'
                    )}
                  </Grid>
                )}

                {/* Expenditure and Total Expenditure Section */}
                <Grid item={programsAndResultsData?.attending_challenge ? true : false} container spacing={2} xs={programsAndResultsData?.attending_challenge ? 6 : false} >
                  {/* Expenditure box */}
                  {programsAndResultsData?.expenditure &&
                    <Grid item xs={programsAndResultsData?.attending_challenge ? 12 : 6}>
                      <Box
                        sx={{
                          backgroundColor: '#EDF2F6',
                          borderRadius: '16px',
                          padding: '16px',
                          mt: 2,
                        }}
                      >
                        <ParagraphComp
                          text="Expenditure on the programme in financial year reported:"
                          className="text-[#004878] text-md font-bold"
                        />
                        <ParagraphComp
                          text={programsAndResultsData?.expenditure ? formatCurrency(programsAndResultsData?.expenditure) : '-'}
                          className="text-[#004878] text-md "
                        />
                      </Box>
                    </Grid>
                  }
                  {/* Total expenditure box */}
                  {programsAndResultsData?.total_expenditure &&
                    <Grid item xs={programsAndResultsData?.attending_challenge ? 12 : 6}>
                      <Box
                        sx={{
                          backgroundColor: '#EDF2F6',
                          borderRadius: '16px',
                          padding: '16px',
                          mt: 2,
                        }}
                      >
                        <ParagraphComp
                          text="Total Expenditure on the programme since its start:"
                          className="text-[#004878] text-md font-bold"
                        />
                        <ParagraphComp
                          text={programsAndResultsData?.total_expenditure ? formatCurrency(programsAndResultsData?.total_expenditure) : '-'}
                          className="text-[#004878] text-md "
                        />
                      </Box>
                    </Grid>
                  }

                </Grid>
              </Grid>

              {programsAndResultsData?.story_image_1 || programsAndResultsData?.story_image_2 || programsAndResultsData?.story_image_3 ?
                <Grid container spacing={2} sx={{ mt: .5 }}>



                  <Grid item xs={6} sx={{ backgroundColor: '#EDF2F6', mt: 4, borderRadius: '16px', padding: '16px' }}>
                    <Box sx={{ mt: 0 }}>
                      {/* <ParagraphComp text='Images of the story (upto 3)' className='text-[#004878] text-2xl mb-2 font-bold ml-2' />
                      <Divider sx={{ color: '#E5E8EB', marginTop: '15px', borderBottomWidth: 3 }} /> */}
                      <ParagraphComp text='Images of the story (upto 3)' className='text-[#004878] text-md font-bold' />

                      <div className="flex gap-[10px] mt-1">
                        {programsAndResultsData?.story_image_1 && (
                          <div style={containerStyle}>
                            <img
                              src={`data:image/png;base64,${programsAndResultsData?.story_image_1}`}
                              alt="logo"
                              style={imageStyle}
                            />
                          </div>
                        )}
                        {programsAndResultsData?.story_image_2 && (
                          <div style={containerStyle}>
                            <img
                              src={`data:image/png;base64,${programsAndResultsData?.story_image_2}`}
                              alt="logo"
                              style={imageStyle}
                            />
                          </div>
                        )}
                        {programsAndResultsData?.story_image_3 && (
                          <div style={containerStyle}>
                            <img
                              src={`data:image/png;base64,${programsAndResultsData?.story_image_3}`}
                              alt="logo"
                              style={imageStyle}
                            />
                          </div>
                        )}
                      </div>
                    </Box>
                  </Grid>

                  {programsAndResultsData?.story ?
                    <Grid sx={{ display: 'flex', flexDirection: 'column' }} item xs={programsAndResultsData?.what_we_do ? 12 : 6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', paddingBottom: '0', mt: 2, flex: 1 }}>
                        <ParagraphComp text='Story from the ground about the Programme' className='text-[#004878] text-md font-bold' />
                        <ParagraphComp text={programsAndResultsData?.story || '-'} className='text-[#004878] text-md ' />
                      </Box>
                    </Grid> :
                    <Grid sx={{ height: 'auto' }} item xs={programsAndResultsData?.what_we_do ? 12 : 6}>

                    </Grid>
                  }
                </Grid >
                : <></>}


              <Grid container spacing={2} sx={{ mt: .5 }}>
                {programsAndResultsData?.what_we_do &&
                  <Grid item xs={6}>
                    {RenderParagraphPair('What has been the performance against the indicators in the FY', programsAndResultsData?.what_we_do)}
                  </Grid>
                }
                <Grid item={programsAndResultsData?.what_we_do ? true : false} container spacing={2} xs={programsAndResultsData?.what_we_do ? 6 : false} sx={{ mt: .5 }}>


                  {/* {programsAndResultsData?.story ?
                    <Grid sx={{ height: 'auto' }} item xs={programsAndResultsData?.what_we_do ? 12 : 6}>
                      <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2, height: '100%' }}>
                        <ParagraphComp text='Story from the ground about the Programme' className='text-[#004878] text-md font-bold' />
                        <ParagraphComp text={programsAndResultsData?.story || '-'} className='text-[#004878] text-md ' />
                      </Box>
                    </Grid>:
                    <Grid sx={{ height: 'auto' }} item xs={programsAndResultsData?.what_we_do ? 12 : 6}>
                      
                    </Grid>
                  } */}
                  <Grid item sx={{ height: 'auto' }} xs={programsAndResultsData?.what_we_do ? 12 : 6}>

                  </Grid>


                </Grid>
              </Grid >

              <Grid container spacing={2} sx={{ mt: .5 }}>
                {programsAndResultsData?.key_indicator &&
                  <Grid item xs={6}>
                    {RenderParagraphPair('Programme Indicators used to track progress', programsAndResultsData?.key_indicator || '-')}
                  </Grid>
                }
                {programsAndResultsData?.key_indicator &&
                  <Grid item xs={6}>
                    {RenderParagraphPair('What has been the performance trend ', programsAndResultsData?.explain_supporting_fact || '-')}
                  </Grid>
                }

              </Grid>


              <Grid container spacing={2} sx={{ mt: .5 }}>

                {programsAndResultsData?.narratives &&
                  <Grid item xs={6}>
                    {RenderParagraphPair('What is the impact on the target segment(s) since the programme started', programsAndResultsData?.narratives || '-')}
                  </Grid>
                }
                <Grid item xs={6}>
                  <Box sx={{ mt: 2, ml: 1 }}>
                    {programsAndResultsData?.supporting_fact &&
                      <>
                        {RenderParagraphPair("How this initiative aligns with the organisation's values and goals and is relevant to the target audience", programsAndResultsData?.supporting_fact || '-')}
                      </>
                    }

                  </Box>

                </Grid>
                {programsAndResultsData?.supporting_fact_positive_impact &&
                  <Grid item xs={6}>
                    {RenderParagraphPair('How the initiative is sustainable and if it can continue to make a positive impact in the future', programsAndResultsData?.supporting_fact_positive_impact || '-')}
                  </Grid>
                }



              </Grid >
              {/* {programsAndResultsData?.supporting_fact &&
                <Grid container spacing={2} sx={{ mt: .5 }}>
                  <Grid item xs={6} onClick={()=>scrollToSection()} sx={{cursor:'pointer'}}>
                    {RenderParagraphPair('Want to support this programme?', programsAndResultsData?.supporting_fact || '-')
                    }
                  </Grid>
                  <Grid item xs={6}>
                  </Grid>
                </Grid>
              } */}
              <Grid container spacing={2} sx={{ mt: .5 }}>
                {programsAndResultsData?.key_indicator &&
                  <Grid item xs={6} onClick={() => scrollToSection()} sx={{ cursor: 'pointer' }}>
                    <Box sx={{ mt: 3, width: '100%' }}>
                      <ParagraphComp text={'Want to support this programme? '} className='text-[#004878] text-2xl mb-2 font-bold' />
                      <Divider sx={{ color: '#E5E8EB', borderBottomWidth: 3 }} />
                      <div className='flex gap-1'>

                        <ParagraphComp text={'Explore ways to'} className=' mt-1 text-2xl font-bold text-justify' />
                        <ParagraphComp text={'Get Involved'} className='text-[#d0353c] mt-1 text-2xl font-bold text-justify' />
                      </div>
                    </Box>
                  </Grid>
                }

                {programsAndResultsData?.assessment_carried_out &&
                  <Grid item={programsAndResultsData?.key_indicator ? true : false} xs={6}>
                    <Box sx={{ backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2 }}>
                      <ParagraphComp text='Programme assessment was carried out by:' className='text-[#004878] text-md font-bold' />
                      <ParagraphComp text={programsAndResultsData?.assessment_carried_out || '-'} className='text-[#004878] text-md ' />
                    </Box>
                  </Grid>
                }
              </Grid>
              <Grid container spacing={2} sx={{ mt: .5 }}>
                <Grid item xs={6}>

                </Grid>
                {programsAndResultsData?.last_assessment_carried_out &&
                  <Grid item sx={{ height: 'auto' }} xs={programsAndResultsData?.what_we_do ? 12 : 6}>
                    <Box sx={{ display: 'flex', backgroundColor: '#EDF2F6', borderRadius: '16px', padding: '16px', mt: 2, height: '100%' }}>
                      <ParagraphComp text={`Last assessment was carried out: ${programsAndResultsData?.last_assessment_carried_out || '-'}`} className='text-[#004878] text-md font-bold' />
                    </Box>
                  </Grid>
                }
              </Grid>
            </>
            :
            < ParagraphComp text='No data provided for this section.' className='text-[black] text-xl mt-[20px] font-thin' />
          }
        </Box >

        }

      </div >
    </>
  )
};
